import {Outlet, useLocation} from "react-router-dom";
import {Header} from "../components/Header";
import {useEffect} from "react";
import Cactus from "../assets/Cactus.png";

export const Footer = () => (
  <>
    <img
      className={"h-auto w-[30vw] opacity-75 object-cover"}
      src={Cactus}
      alt={"Cactus"}
    />
    <div className={"h-max w-full bg-gray-400 px-4 text-[8px] font-sans"}>
      LukeForNM.com was produced In-House. Site History:{" "}
      <a
        target="_blank"
        href="https://github.com/useTheReduceLuke/lukefornm"
        rel="noreferrer"
      >
        github.com/useTheReduceLuke/lukefornm
      </a>
    </div>
  </>
);

export const Root = () => {
    const location = useLocation();

    const scrollToTop = (smooth = true) => {
        const scrollRef = document.getElementById("scrollRef");
        scrollRef?.scrollIntoView({ behavior: smooth ? "smooth" : "auto" });
    };

    useEffect(() => {
        scrollToTop(false);
    }, [ location ]);

    return (
        <>
            <span id={"scrollRef"} className={"h-0 w-full"}/>
            <Header/>
            <Outlet/>
             {/*<Information/>*/}
        </>
    );
};
